/**
 * @Author: Zero
 * @Date: 2024-01-15 12:34:42
 * @Explain: radio 切换
 */

import { intlGet } from '@/locales';
import type { ReactNode } from 'react';
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { Radio } from 'tdesign-react';
// components
import TitleBlock from '@/pages/contactManage/addOrEdit/components/titleBlock';
// utils
import classNames from 'classnames';

interface propsType {
  /** 切换tab后回调 */
  themeCallback?: Function;
  /** tab 下描述 */
  descDom?: (theme: string | number) => string | ReactNode;
  /** tab */
  radioTab: {
    value: any;
    text?: any;
    desc?: any;
    label?: any;
    labelKey?: string;
  }[];
  value?: number | string;
  /** actions **/
  actions?: ReactNode;
  /** 禁止点击 */
  disabled?: boolean;
  /** 类名 */
  className?: string;
}
const RadioTab = (props: propsType, refs: any) => {
  const {
    themeCallback,
    radioTab,
    value,
    actions,
    disabled = false,
    className,
    descDom,
  } = props;
  // 更多表格切换项目
  const [theme, setTheme] = useState<number | string>(
    value || radioTab[0].value,
  );

  // 重置切换选项
  const resetRadioTab = useCallback(() => {
    setTheme(radioTab[0].value);
  }, [radioTab[0].value]);

  useEffect(() => {
    value && setTheme(value);
  }, [value]);

  // 绑定ref，抛出方法
  useImperativeHandle(refs, () => ({
    theme,
    resetRadioTab,
  }));
  return (
    <>
      <div className={classNames('flex-block flex-justify-between', className)}>
        <div className="flex-1 mr-20">
          <Radio.Group
            disabled={disabled}
            className="default-radio-tab"
            variant="default-filled"
            value={theme}
            onChange={(val: any) => {
              setTheme(val);
              themeCallback && themeCallback(val);
            }}
          >
            {radioTab.map((item, index) => (
              <Radio.Button key={index} value={item.value}>
                {intlGet(item?.labelKey) || item?.label || item?.text}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
        <div className={classNames('actions', { hide: !actions })}>
          {actions}
        </div>
      </div>

      {descDom ? (
        <TitleBlock
          className={classNames('mt-14 mb-20', className)}
          desc={descDom(theme)}
        />
      ) : null}
    </>
  );
};

export default forwardRef(RadioTab);
